module.exports = __webpack_public_path__ + "img/25exp.70d25dbd.jpg";